import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

import translation_en from './en.json'
import translation_zh from './zh.json'

const resources = {
  en_US: {
    translation: translation_en,
  },
  zh_CN: {
    translation: translation_zh,
  },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'zh_CN',
    interpolation: {
      escapeValue: false,
    },
  }).then()

export default i18n